export const environment = {
  googleMapEmbedApiKey: 'AIzaSyCMNz8jKD_LsQW5yuURWn8J6a_qJMG-z40',
  recaptchaKey: '6Lc6NSsqAAAAAG-pac8xr0j7scwi7BYTMKvxxkoR',
  googleMapId: 'ca6193af1f86a7ea', // matt's dev map,
  apiDomain: 'https://mobileapi.nvms.com',
  oneSignalAppId: '222b29cc-024f-4dcd-aa25-d1aa79c2e485',
  capacitorAppId: 'com.nvms.nvmsconnect.dev',
  liveUpdate: {
    appId: 'e01f6b48',
    channel: 'Development',
  },
};
